// prism theme
import './static/prism-theme.css'
// katex math rendering
import 'katex/dist/katex.min.css'
import { wrapRootElement as wrap } from './src/components/wrap-root-element'

// eslint-disable-next-line import/prefer-default-export
export const wrapRootElement = wrap
